export default {
  serverURI: 'https://www.jianzb.cn/',
  // serverURI: 'http://192.168.2.140:9637/',
  // serverURI: 'http://dever.jianzb.cn/',
  version: '1.0.0'
}
